import React, { useCallback, useEffect, useState } from "react";
import BreadCumb from "../../Component/BreadCumb";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getAllCourse,
  deleteCourse,
  getAllContact,
  deleteContact,
  exportContact,
} from "../../Libs/api";
import Loader from "../../Component/Loader";
import Swal from "sweetalert2";
import EditButton from "../../Component/EditButton";
import DeleteButton from "../../Component/DeleteButton";
import { Pagination } from "antd";
import ViewButton from "../../Component/ViewButton";
import ViewContact from "./ViewContact";
import moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const ContactList = () => {
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [loading, setloading] = useState(false);
  const [allContact, setAllContact] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const callAPI = useCallback(async (limit, offset) => {
    try {
      setloading(true);
      const apiCall = await getAllContact({ limit, offset });
      if (apiCall.status) {
        setAllContact(apiCall?.data?.rows);
        setTotalCount(apiCall?.data?.count);
        setloading(false);
      } else {
        toast.error(apiCall?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    callAPI(limit, offset);
    // eslint-disable-next-line
  }, [callAPI, limit, offset]);

  const handleDelete = async (id) => {
    await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let formData = {
          id: id,
        };

        setloading(true);

        try {
          const apiCall = await deleteContact(formData);
          if (apiCall.status) {
            console.log(apiCall, "apiCall");

            callAPI(limit, offset);
          } else {
            setloading(false);
            toast.error(apiCall?.message);
          }
        } catch (error) {
          setloading(false);
          console.log(error);
          toast.error(error);
        }
      }
    });
  };

  const handleOnChange = (page) => {
    console.log("page: ", page);
    setOffset(page * limit - limit);
  };

  const handleChangeSize = (current, size) => {
    setOffset(0);
    setLimit(size);
  };

  const handleExport = async () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = `Contact-Report`;

    try {
      setloading(true);
      const apiCall = await exportContact();
      if (apiCall.status) {
        const apiData = apiCall?.data?.rows?.map((er) => ({
          Date: moment(er?.updatedAt).format("DD-MM-YYYY"),
          Name: `${er?.name || ""}`,
          Email: er?.email,
          "Mobile No": er?.phoneNo || "",
          Subject: er?.subject || "",
        }));

        let columnWidths = [40, 40, 40, 40, 40, 40];

        const ws = XLSX.utils.json_to_sheet(apiData);
        ws["!cols"] = columnWidths.map((width) => ({ wch: width }));

        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);

        setloading(false);
      } else {
        setloading(false);
        toast.error(apiCall?.message);
      }
    } catch (error) {
      setloading(false);
      console.log(error);
      toast.error(error?.message || "Export failed");
    }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div class="page-body">
      <BreadCumb title={"Contact List"} subtitle={"General"} />
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="list-product-header">
                  <div>
                    <Link
                      class="btn btn-primary"
                      onClick={() => {
                        handleExport();
                      }}
                    >
                      <i class="fa fa-download"></i>Export
                    </Link>
                  </div>
                </div>

                <div class="list-product">
                  <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
                    <div class="datatable-container">
                      <table class="table datatable-table" id="project-status">
                        <thead>
                          <tr>
                            <th data-sortable="true" style={{ width: "15%" }}>
                              <span class="f-light f-w-600">Name </span>
                            </th>
                            <th data-sortable="true" style={{ width: "20%" }}>
                              <span class="f-light f-w-600">Email </span>
                            </th>
                            <th data-sortable="true" style={{ width: "15%" }}>
                              <span class="f-light f-w-600">Mobile No</span>
                            </th>
                            <th data-sortable="true" style={{ width: "20%" }}>
                              <span class="f-light f-w-600">Subject</span>
                            </th>
                            <th data-sortable="true" style={{ width: "15%" }}>
                              <span class="f-light f-w-600">Created At</span>
                            </th>

                            <th data-sortable="true" style={{ width: "15%" }}>
                              <span class="f-light f-w-600">Action</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {allContact?.map((item, i) => {
                            return (
                              <tr key={i} data-index={i}>
                                <td>
                                  <p class="">{item?.name}</p>
                                </td>
                                <td>
                                  <p class="">{item?.email}</p>
                                </td>
                                <td>
                                  <p class="">{item?.phoneNo}</p>
                                </td>
                                <td>
                                  <p class="">{item?.subject}</p>
                                </td>

                                <td>
                                  <p class="f-light">
                                    {moment(item?.createdAt).format(
                                      "DD-MM-YYYY HH:MM A"
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <div class="product-action">
                                    <ViewButton
                                      onClickFunction={() => {
                                        setViewModal(true);
                                        setSingleData(item);
                                      }}
                                    />
                                    <DeleteButton
                                      onClickFunction={() => {
                                        handleDelete(item?.id);
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="mt-4 d-flex justify-content-end">
                  <Pagination
                    defaultCurrent={1}
                    total={totalCount}
                    defaultPageSize={limit}
                    current={offset / limit + 1}
                    onChange={handleOnChange}
                    showSizeChanger={true}
                    onShowSizeChange={handleChangeSize}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {viewModal && (
        <ViewContact
          singleData={singleData}
          openModal={viewModal}
          onClose={() => {
            setViewModal(false);
            callAPI(limit, offset);
          }}
        />
      )}
    </div>
  );
};

export default ContactList;
